import React from 'react'
import { connect } from 'react-redux'
import { setUserPreferences } from '../../../../../action/user-preferences'

class Coordinates extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { coordinates } = this.props.userPreferences,
      { setUserPreferences } = this.props

    return (
      <div>
        <div className='settings-units-container'>
          <h2>Coordinate System</h2>
          <div className='settings-input-row'>
            <div style={{ width: '165px' }}>
              <input type='radio' id='decimal' name='decimal' checked={coordinates === 'decimal'}
                onChange={() => {
                  if (coordinates !== 'decimal') {
                    setUserPreferences({ coordinates: 'decimal' })
                    this.forceUpdate()
                  }
                }}
              />
              <label htmlFor='imperial'>Decimal Degrees</label>
              <p style={{
                fontSize: '12px',
                color: 'white',
                width: '100%',
                paddingLeft: '20px'
              }}>Ex: 00.00000</p>
            </div>
            <div style={{ width: '67%' }}>
              <input type='radio' id='dms' name='dms' checked={coordinates === 'dms'}
                onChange={() => {
                  if (coordinates !== 'dms') {
                    setUserPreferences({ coordinates: 'dms' })
                    this.forceUpdate()
                  }
                }}
              />
              <label htmlFor='dms' className='degree-Minutes-Seconds'>Degree/Minutes/Seconds</label>
              <p style={{
                fontSize: '12px',
                color: 'white',
                width: '100%',
                paddingLeft: '20px'
              }}>Ex: 00 00' 00"</p>
            </div>
          </div>
          <div className='settings-input-row' style={{ marginTop: '10px' }}>
            <div style={{ width: '165px' }}>
              <input type='radio' id='utm' name='utm' checked={coordinates === 'utm'}
                onChange={() => {
                  if (coordinates !== 'utm') {
                    setUserPreferences({ coordinates: 'utm' })
                    this.forceUpdate()
                  }
                }}
              />
              <label htmlFor='utm'>UTM</label>
              <p style={{
                fontSize: '12px',
                color: 'white',
                width: '100%',
                paddingLeft: '20px'
              }}>Ex: 12T 456789E 4567890N</p>
            </div>
          </div>
          <div className='settings-entry-header'>
            CHOOSE THE COORIDINATE SYSTEM YOU PREFER
          </div>
          <div style={{ fontSize: '12px', padding: '5px' }}>
            Changing your Coordinate System will change the way latitude and longitude display on the map, as well as, when you place a marker, photo, or edit objects.
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  userPreferences: state.userPreferences
})

const mapDispatchToProps = dispatch => ({
  setUserPreferences: preferences => { dispatch(setUserPreferences(preferences)) }
})

export default connect(mapStateToProps, mapDispatchToProps)(Coordinates)